import { render, staticRenderFns } from "./VariantSifterAiAssistantPanel.vue?vue&type=template&id=318865b4&scoped=true&"
import script from "./VariantSifterAiAssistantPanel.vue?vue&type=script&lang=js&"
export * from "./VariantSifterAiAssistantPanel.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterAiAssistantPanel.vue?vue&type=style&index=0&id=318865b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318865b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('318865b4')) {
      api.createRecord('318865b4', component.options)
    } else {
      api.reload('318865b4', component.options)
    }
    module.hot.accept("./VariantSifterAiAssistantPanel.vue?vue&type=template&id=318865b4&scoped=true&", function () {
      api.rerender('318865b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterAiAssistantPanel.vue"
export default component.exports